/**
 * This method will extract the nudge attributes from the element if they are available
 *
 * @param element The element to extract the nudge attributes from
 * @returns An object with the nudge attributes
 */
export function getNudgePropertiesFromAttributes(element) {
  const nudgeId = element.id || element.dataset.nudgeId;
  const nudgeGoal = element.dataset.nudgeGoal;
  const nudgeContext = element.dataset.nudgeContext;
  return Object.assign({}, nudgeId ? {
    id: nudgeId
  } : {}, nudgeGoal ? {
    goal: nudgeGoal
  } : {}, nudgeContext ? {
    context: nudgeContext
  } : {});
}